import { useEffect, useRef } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useHub } from "@/hub/HubContext";

const TONE = { out: "text-foreground", info: "text-primary", error: "text-destructive" };

export const ConsolePanel = () => {
  const { logs, clearLogs } = useHub();
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ block: "end" });
  }, [logs]);

  return (
    <div className="flex h-full min-h-0 flex-col" data-testid="console-panel">
      <div className="flex items-center justify-between border-b px-4 py-2.5">
        <p className="text-xs text-muted-foreground">Messages from HubPilot and your hub, like when the controller connects.</p>
        <Button size="sm" variant="ghost" onClick={clearLogs} data-testid="clear-console-button"><Trash2 className="h-4 w-4" /></Button>
      </div>
      <div className="min-h-0 flex-1 overflow-auto bg-muted/40 p-3 font-code text-[12px] leading-relaxed" data-testid="console-log">
        {logs.length === 0 && <p className="text-muted-foreground">Nothing yet. Connect a hub and press Drive.</p>}
        {logs.map((l) => (
          <div key={l.id} className="flex gap-2">
            <span className="shrink-0 text-muted-foreground/60">{l.t.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })}</span>
            <span className={`${TONE[l.kind]} whitespace-pre-wrap break-words`}>{l.text}</span>
          </div>
        ))}
        <div ref={endRef} />
      </div>
    </div>
  );
};
